
<template>
  <v-navigation-drawer
    :permanent="!isOnMobile"
    :temporary="isOnMobile"
    width="280"
    class="customscroll elevation-2"
    v-model="IF.showMenu"
    :style="`background-color: ${Colors.MenuColor}`"
    ref="refNavigationDrawer"
  >
    <div class="box-container">
      <v-divider class="row-header"></v-divider>
      <div class="row-header">
        <v-list-item style="cursor: pointer" @click="openWebSite('https://ev.tremol.bg/')">
          <v-img :src="require('@/assets/EVp1.png')" style="max-height: 66px"></v-img>
          <t-divider class="ma-0 mt-2"></t-divider>
        </v-list-item>
        <v-list-item style="" align="center" justify="center">
          <span :style="`color: ${Colors.MenuTextColor}`">{{ DataManager.user.orgName }}</span>
        </v-list-item>
      </div>
      <div class="row-content">
        <v-list v-model:opened="expanded_groups" class="ma-0 px-0 noselect" :style="`background-color: ${Colors.MenuColor}`" :lines="false">
          <template v-for="(gr, index) in getGroups">
            <template v-if="gr.isSingle">
              <v-tooltip v-for="route in getRoutesByGroupName(gr.name)" :key="route.name" :disabled="!!(!IF.ShowTooltips || isOnMobile)" location="right">
                <template v-slot:activator="{ props }">
                  <v-list-item
                    v-bind="props"
                    :class="IF.MyFont"
                    @click="selectTab(route)" 
                    :style="routerCurrentPath.name == route.name ? 'background: ' + Colors.ActiveItemBackground : ''"
                  >
                    <v-icon :color="Colors.IconColor" class="mr-3">{{ route.meta.icon }}</v-icon>
                    <v-badge offset-x="20" offset-y="22" v-if="checkEvents(route)" color="red" overlap :bordered="!isInDarkMode">
                      <template v-slot:badge>
                        <span>{{ route.meta.datatype.events }}</span>
                      </template>
                    </v-badge>
                    <span :style="`color: ${Colors.MenuTextColor}`">{{ route.meta.title }}</span>
                  </v-list-item>
                </template>
                {{ route.meta.description }}
              </v-tooltip>
            </template>
            <template v-else>
              <v-list-group :key="index" :value="index">
                <template v-slot:activator="{ props }">
                  <v-list-item v-bind="props" :class="IF.MyFont">
                    <v-icon :color="Colors.IconColor" class="mr-3">{{ gr.icon }}</v-icon>
                    <v-badge offset-x="20" offset-y="22" v-if="expanded_groups.indexOf(index) == -1 && gr.events" color="red" overlap :bordered="!isInDarkMode">
                      <template v-slot:badge>
                        <span>{{ gr.events }}</span>
                      </template>
                    </v-badge>
                    <span :style="`color: ${Colors.MenuTextColor}`">{{ gr.name }}</span>
                  </v-list-item>
                </template>
                <v-tooltip v-for="(route, i) in getRoutesByGroupName(gr.name)" :key="i" :disabled="!!(!IF.ShowTooltips || isOnMobile)" location="right">
                  <template v-slot:activator="{ props }">
                    <v-list-item
                      v-bind="props"
                      class="ml-0 pl-2"
                      :class="IF.MyFont"
                      @click="selectTab(route)"
                      :style="routerCurrentPath.name == route.name ? 'background: ' + Colors.ActiveItemBackground : ''"
                    >
                      <v-icon :color="Colors.IconColor" class="mr-3">{{ route.meta.icon }}</v-icon>
                      <v-badge offset-x="20" offset-y="22" v-if="checkEvents(route)" color="red" overlap :bordered="!isInDarkMode">
                        <template v-slot:badge>
                          <span>{{ route.meta.datatype.events }}</span>
                        </template>
                      </v-badge>
                      <span :style="`color: ${Colors.MenuTextColor}`">{{ route.meta.title }}</span>
                    </v-list-item>
                  </template>
                  {{ route.meta.description }}
                </v-tooltip>
              </v-list-group>
            </template>
          </template>
        </v-list>
      </div>
      <v-divider class="row-header"></v-divider>
      <template v-if="DataManager.user.userType == DataManager.UserTypes.SuperUser">
        <v-switch
          class="row-header ma-0 pa-0 mx-4"
          readonly
          density="compact"
          hide-details
          v-show="isOnTestServer"
          v-model="isOnTestServer"
          :color="Colors.IconColor"
        >
          <template v-slot:label>
            <span :class="IF.MyFont">Тестов сървър</span>
          </template>
        </v-switch>
      </template>
      <span class="mа-0 pa-2" style="text-align: end; font-size: 12px">{{ "v. " + getAppVer() }}</span>
      <v-divider class="row-header"></v-divider>
      <div class="row-header ma-2 mx-4">
        <v-btn text block variant="outlined" base-color="error" :class="IF.MyFont" @click="logout()">
          <span>Изход</span>
          <v-icon small>mdi-logout</v-icon>
        </v-btn>
      </div>
    </div>
  </v-navigation-drawer>

  <v-main v-if="$route.fullPath" ref="refMainContainer" @resize="resizeMain()">
    <v-app-bar density="compact" :style="'background-color: ' + Colors.MenuColor">
      <v-row class="ma-0 pa-0" align="center" justify="center">
        <v-app-bar-nav-icon v-if="isOnMobile" @click.stop="IF.showMenu = !IF.showMenu"></v-app-bar-nav-icon>
        <v-spacer v-if="!isOnMobile"></v-spacer>
        <template v-if="routerCurrentPath && routerCurrentPath.meta">
          <v-card-title :class="isOnMobile ? IF.MyFont : IF.MyFontTitle">
            {{ isOnMobile ? routerCurrentPath.meta.title : routerCurrentPath.meta.description }}
          </v-card-title>
        </template>
        <v-spacer></v-spacer>
      </v-row>
    </v-app-bar>

    <div class="box-container ma-0 pa-0" :style="'height: ' + mainContainerHeight + 'px;'">
      <router-view :key="$route.fullPath"></router-view>
    </div>
  </v-main>
  <!-- <v-footer app v-if="showLog && getLog" padless inset :height="300">
      <v-card class="ma-2 pa-2" :elevation="25" :height="300" width="100%" outlined>
        <v-virtual-scroll :height="300" :item-height="20" :items="getLog">
          <template v-slot="{ item, index }">
            <span :key="index" class="subtitle-2"> {{ `${item.Date.toTremolFpString()} ${item.User} ${item.Action} ${item.TableName} => ${getChanges(item.Value, item.OldValue)}` }}</span>
          </template>
        </v-virtual-scroll>
      </v-card>
    </v-footer> -->
</template>

<script>
import DataManager from "./data/DataManager";
import { g_Dialog, g_Events } from "./main";
import packageInfo from "../package.json";
import { ref } from "vue";
import { useLayout } from "vuetify/lib/framework.mjs";
// import bus, { g_Dialog } from '@/main';
// import Notifications from "./Controls/Notifications";
// import HTTPSender from "../js/HTTPSender";

export default {
  // props: ["userprop"],
  components: {
    // Notifications,
  },
  data() {
    return {
      DataManager: DataManager,
      tree: [],
      treeActive: [],
      treeOpen: [],
      selectedNote: null,
      expanded_groups: [],
      mobileMenu: false,
      showLog: true,
      reloadTransactionInterval: null,
      reloadTransactionTime: 10000,
      reloadStatusInterval: null,
      reloadStatusTime: 10000,
    };
  },
  methods: {
    getAppVer() {
      return packageInfo.version;
    },
    async loadStatus() {
      if (DataManager.data.ChargeStation.isLoading) {
        return;
      }
      await DataManager.loadData(DataManager.data.ChargeStation);
      this.bus.emit(g_Events.ChargeStationRefresh);
    },
    loadTransactions(firstLoad) {
      var append = DataManager.data.DailyTransactions.dates[1].getDateWithoutTime().getTime() == new Date().getDateWithoutTime().getTime();
      if (!append || firstLoad) {
        DataManager.data.DailyTransactions.data = [];
      }
      DataManager.data.DailyTransactions.dates[1] = new Date();
      this.$nextTick(() => {
        DataManager.loadData(
          DataManager.data.DailyTransactions,
          () => {
            DataManager.data.DailyTransactions.dates[0] = DataManager.data.DailyTransactions.dates[1];
          },
          append
        );
      });
    },
    resizeMain() {
      //TODO @resize not working
      // console.log("resizeMain");
      var rect = useLayout().mainRect.value;
      // console.log(rect);
      return rect;
    },
    logout() {
      // this.booleans.isLoading = true;
      DataManager.__reload();
      this.$nextTick(() => {
        this.$router
          .push({ path: "/login" })
          .catch(() => {})
          .then(() => {
            this.$vuetify.theme.dark = false;
            document.title = "Tremol EV Management System";
            // this.booleans.isLoading = false;
            this.$router.go();
          });
      });
    },
    checkEvents(route) {
      return route.meta.datatype && route.meta.datatype.events > 0;
    },
    getRoutesByGroupName(name) {
      return this.routes.filter((r) => r.meta.group == name);
    },
    selectTab(route) {
      if (this.routes.indexOf(route) == -1) {
        route = this.routes.find((f) => f.name == route.name);
      }
      if (!route) {
        return;
      }
      if (route.path != this.$router.currentRoute.path) {
        this.$router.push({ name: route.name }).catch(() => {});
      }
      var foundGroupIdx = this.getGroups.findIndex((g) => g.name == route.meta.group && !g.isSingle);
      if (foundGroupIdx != -1 && this.expanded_groups.indexOf(foundGroupIdx) == -1) {
        this.expanded_groups.push(foundGroupIdx);
      }
      this.mobileMenu = false;
    },
  },
  computed: {
    routes() {
      return this.$router.options.routes
        .find((f) => f.name == "MainContent")
        .children.filter((c) => c.meta && !c.meta.hidden && DataManager.userHasAccess(c.meta.for_user));
    },
    getGroups() {
      var groups = this.routes.map((r) => ({ name: r.meta.group, icon: r.meta.group_icon, isSingle: false, events: null }));
      groups.forEach((g) => {
        g.isSingle = this.routes.map((r) => r.meta.group).isElementUnique(g.name);
        g.events = this.routes
          .filter((r) => r.meta && r.meta.group && r.meta.group == g.name && r.meta.events)
          .map((r) => r.meta.events)
          .sum();
      });
      return groups.unique();
    },
    routerCurrentPath() {
      return this.$router.currentRoute.value;
    },
  },
  watch: {
    // treeOpen: function (val, val2) {
    //   console.log("tree open changed! " + val + "  " + val2);
    //   // if (id) {
    //   //   this.openInternalLink("Ticket", { filter: "Product", filterid: id });
    //   // }
    // },
  },
  created() {},
  async mounted() {
    if (this.$route.query.message) {
      this.$nextTick(() => {
        g_Dialog.showInfo(this.$route.query.message);
      });
    }

    // this.expanded_groups = [...Array(this.getGroups.length).keys()];
    this.$nextTick(() => {
      this.selectTab(this.routerCurrentPath);

      // window.history.replaceState({}, document.title, window.location.origin);
    });
    await this.loadStatus();
    await this.loadTransactions(true);
    if (!this.reloadTransactionInterval) {
      this.reloadTransactionInterval = setInterval(this.loadTransactions, this.reloadTransactionTime);
    }
    if (!this.reloadStatusInterval) {
      this.reloadStatusInterval = setInterval(this.loadStatus, this.reloadStatusTime);
    }
  },
  updated() {},
  setup() {
    const refMainContainer = ref(null);
    const refNavigationDrawer = ref(null);
    return { refMainContainer, refNavigationDrawer };
  },
};
</script>

<style scoped>
/* .v-list-item >>> span,
.v-list-group >>> span {
  font-size: 15px; 
}
.list-item-text {
  font-size: 14px;
}
*/

.closeBtn:hover:before {
  background-color: transparent;
}

div >>> .v-toolbar__content {
  padding: 0;
}

div >>> .v-banner__wrapper {
  border: 5px solid yellow;
}

div >>> .tremol-logo-btn {
  justify-content: start;
}

.bordered-item {
  margin: auto;
  display: flex;
  width: 204px;
  height: 204px;
}

.v-menu {
  margin-top: 40px;
  contain: initial;
  overflow: visible;
}
.v-menu::before {
  position: absolute;
  content: "";
  top: 0;
  right: 10px;
  transform: translateY(-100%);
  width: 10px;
  height: 13px;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 13px solid #fff;
}
</style>